import { render, staticRenderFns } from "./NewVideoContent.vue?vue&type=template&id=1313a99c&scoped=true&"
import script from "./NewVideoContent.vue?vue&type=script&lang=js&"
export * from "./NewVideoContent.vue?vue&type=script&lang=js&"
import style0 from "./NewVideoContent.vue?vue&type=style&index=0&id=1313a99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313a99c",
  null
  
)

export default component.exports